<template>
    <el-form :model="form"label-width="150px">
        <el-row>
            <el-col :span="12">
                <el-form-item label="政府名称">
                    {{ form.entName }}
                </el-form-item>
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="12">
                <el-form-item label="联系人">
                    {{ form.contactName }}
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="联系方式" prop="entName">
                    <span>{{ form.contactPhone }}</span>
                </el-form-item>
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="12">
                <el-form-item label="负责人">
                    {{ form.legalName }}
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="联系方式" prop="entName">
                    <span>{{ form.legalPhone }}</span>
                </el-form-item>
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="24">
                <el-form-item label="注册地址">
                    {{ form.regAddressName+form.regAddressDetail }}
                </el-form-item>
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="24">
                <el-form-item label="办公地址">
                    {{ form.workAddressName+form.workAddressDetail }}
                </el-form-item>
            </el-col>

        </el-row>
        <el-row>
            <el-col :span="24">
                <el-form-item label="管辖地址">
                    {{ form.addressStreetName+form.addressStreetDetail }}
                </el-form-item>
            </el-col>

        </el-row>
        <slot name="audit">
            <el-row style="padding-top:20px;">
                <div class="dialog-footer" style="padding-left: 40%">
                    <el-button @click="closeDialog()" size="small">关 闭</el-button>
                </div>
            </el-row>
        </slot>
    </el-form>
</template>

<script>
    import {
        enterpriseDetail
    } from '@/api/admin/sysEnterprise/index';
  import { mapGetters } from 'vuex';
  export default {
    name: 'enterpriseDetail',
    props:["entId"],
    data() {
      return {
          form:{

          }
      }
    },
    created() {
      this.init();
    },
    computed: {
      ...mapGetters([
        'elements'
      ])
    },
    methods: {
        status:function(s){
            if(s==0){
                return "未开通";
            }else if(s==1){
                return "待审核";
            }else if(s==2){
                return "被驳回";
            }else if(s==3){
                return "开通成功";
            }else if(s==-1){
                return "停用";
            }
        },
        init:function(){
            enterpriseDetail({entId: this.entId}).then(response => {
                this.form = response;
            });
        },
        entType:function(type){
            return type==0?"加油企业":"供油企业";
        },
        closeDialog(){
            this.$emit('close')
        }
    }
  }
</script>
